import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SquareLockStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M11.2499 16.5V14.5C11.2499 14.0858 11.5857 13.75 11.9999 13.75C12.4142 13.75 12.7499 14.0858 12.7499 14.5V16.5C12.7499 16.9142 12.4142 17.25 11.9999 17.25C11.5857 17.25 11.2499 16.9142 11.2499 16.5Z"
				fill="currentColor"
			/>
			<path
				d="M15.7499 9V6.5C15.7499 4.42893 14.071 2.75 11.9999 2.75C9.92888 2.75 8.24994 4.42893 8.24994 6.5V9C8.24994 9.41421 7.91416 9.75 7.49994 9.75C7.08573 9.75 6.74994 9.41421 6.74994 9V6.5C6.74994 3.60051 9.10045 1.25 11.9999 1.25C14.8995 1.25 17.2499 3.60051 17.2499 6.5V9C17.2499 9.41421 16.9142 9.75 16.4999 9.75C16.0857 9.75 15.7499 9.41421 15.7499 9Z"
				fill="currentColor"
			/>
			<path
				d="M19.2501 11C19.2501 10.3097 18.6904 9.7501 18.0001 9.75H6.00012C5.30976 9.75001 4.75013 10.3096 4.75012 11L4.7511 20C4.75116 20.6903 5.31078 21.25 6.0011 21.25H18.0001C18.6904 21.2499 19.2501 20.6903 19.2501 20V11ZM20.7501 20C20.7501 21.5188 19.5189 22.7499 18.0001 22.75H6.0011C4.48242 22.75 3.25124 21.5187 3.2511 20L3.25012 11C3.25013 9.48123 4.48132 8.25001 6.00012 8.25H18.0001C19.5189 8.2501 20.7501 9.48128 20.7501 11V20Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SquareLockStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SquareLockStrokeIcon;
